/* global window $, console */

export const startDrag = (event, config) => {
  window.draggedObject = { event, ...config };
  try {
    const previewElement = $("<div></div>")
      .attr("id", "div_preview")
      .css({
        position: "absolute",
        left: 0,
        top: 0,
        zIndex: 2000,
        pointerEvents: "none",
        transform: "translate(" + event.clientX + "px, " + event.clientY + "px)",
      });
    if (config?.previewContent) {
      previewElement.append(config.previewContent);
    } else {
      previewElement.text("Drag preview");
    }
    window.draggedObject.previewElement = previewElement;
    $("body").append(previewElement);

    // If there is an onDragMove, call it immediately to initialize the position
    if (config?.onDragMove) {
      config.onDragMove(event, window.draggedObject);
    }
  } catch (e) {
    console.error("Error during preview set for drag and drop", { error: e, event, config });
  }
  $("body").css("cursor", "grabbing").on("mousemove", dragging).on("mouseup", stopDrag);
};

export const dragging = (event) => {
  if (window.draggedObject.previewElement) {
    // Call custom onDragMove first to allow it to override positioning
    let customPositioning = false;
    if (window.draggedObject.onDragMove) {
      window.draggedObject.onDragMove(event, window.draggedObject);
      customPositioning = true;
    }

    // Only apply default positioning if custom positioning wasn't used
    if (!customPositioning) {
      $("#div_preview").css({
        transform: "translate(" + event.clientX + "px, " + event.clientY + "px)",
      });
    }
  }
};

export const stopDrag = (e) => {
  if (window.draggedObject) {
    console.log("ending dragging", window.draggedObject);
    $("body").off("mousemove", dragging);
    $("body").off("mouseup", stopDrag);
    // reset cursor after drag
    $("body").css("cursor", "");
    if (window.draggedObject?.previewElement) {
      $("#div_preview").remove();
    }
    if (window.draggedObject?.onDragEnd) {
      window.draggedObject.onDragEnd(e, window.draggedObject);
    }
    window.draggedObject = undefined;
  }
};

export const cancelDrag = () => {
  if (window.draggedObject) {
    console.warn("cancelling dragging", window.draggedObject);
    $("body").off("mousemove", dragging);
    $("body").off("mouseup", stopDrag);
    // reset cursor after drag
    $("body").css("cursor", "");
    if (window.draggedObject?.previewElement) {
      $("#div_preview").remove();
    }
    window.draggedObject = undefined;
  }
};
